var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#4795ff;}.cls-6{fill:#4778ff;}.cls-7{fill:#00305f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1339.4,
    cy: 698.8,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(396.9 1879.5) rotate(-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1235.1,
    cy: 718.7,
    rx: 17.2,
    ry: 25,
    transform: "translate(-4.9 1429) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M885.9,1332.9c-10.2-111.3-64-106.3-74.2-217.6s43.6-116.2,33.4-227.5L732.8,897.9c10.2,111.3-43.6,116.2-33.4,227.5s64,106.3,74.2,217.6-43,116.2-33.6,225.6a604.4,604.4,0,0,0,110.3,44.9c3-3.6,6.1-7.4,9.2-11.4C849.3,1490.9,896,1444.2,885.9,1332.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M753.8,1465.1c-9.6,26.1-18,54.3-13.8,103.5a604.4,604.4,0,0,0,110.3,44.9c3-3.6,6.1-7.4,9.2-11.4a331.8,331.8,0,0,1,3.1-85.7A615.4,615.4,0,0,1,753.8,1465.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1100.5,1144a29.2,29.2,0,0,1-15-4.1c-41.3-23.9-79.7-23.9-121,0a30,30,0,0,1-30.1-51.9c29.7-17.2,60.2-26,90.6-26s60.9,8.8,90.6,26a30,30,0,0,1-15.1,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M906.9,909.8H675.5a30,30,0,0,1,0-60H906.9a30,30,0,0,1,0,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1164.1,1332.9c10.2-111.3,64-106.3,74.2-217.6s-43.6-116.2-33.4-227.5l112.3,10.1c-10.2,111.3,43.6,116.2,33.4,227.5s-64,106.3-74.2,217.6,43,116.2,33.6,225.6a604.4,604.4,0,0,1-110.3,44.9c-3-3.6-6.1-7.4-9.2-11.4C1200.7,1490.9,1154,1444.2,1164.1,1332.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1190.5,1602.1c3.1,4,6.2,7.8,9.2,11.4a604.4,604.4,0,0,0,110.3-44.9c2.3-27,.8-47.6-2.5-65.1a609.6,609.6,0,0,1-117.1,36.2A332,332,0,0,1,1190.5,1602.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1143.1,909.8h231.4a30,30,0,0,0,0-60H1143.1a30,30,0,0,0,0,60Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadness);
export default __webpack_public_path__ + "static/media/sadness.b58d7dc538f38e303d655475fa5aac08.svg";
export { ForwardRef as ReactComponent };